import styled from 'styled-components/macro';
import { DefaultIcon } from './Icon';

export const ToggleP = styled.p`
  color: ${props => props.theme.blue};
  text-transform: uppercase;
  font-weight: 500;
  font-size: 1.1rem;
`;
export const ToggleIcon = styled(DefaultIcon)`
  fill: ${props => props.theme.blue};
  margin-right: 10px;
`;

export const IconWrapperDiv = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
